import { render } from "./buscador.vue?vue&type=template&id=9db62486&scoped=true"
import script from "./buscador.vue?vue&type=script&lang=js"
export * from "./buscador.vue?vue&type=script&lang=js"

import "./buscador.vue?vue&type=style&index=0&id=9db62486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db62486"]])

export default __exports__